var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          attrs: { id: _vm.selectId },
          on: { change: _vm.onChange },
          model: {
            value: _vm.selectModel,
            callback: function($$v) {
              _vm.selectModel = $$v
            },
            expression: "selectModel"
          }
        },
        [
          _vm.showAll
            ? _c("el-option", { attrs: { value: null, label: "All dates" } })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.customFields, function(label, value) {
            return [_c("el-option", { attrs: { value: value, label: label } })]
          }),
          _vm._v(" "),
          _vm._l(_vm.dates, function(date, i) {
            return _c("el-option", {
              key: i,
              attrs: { value: date.value, label: date.text }
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45225660", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45225660","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Common/RecentDatesSelector.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-45225660","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Common/RecentDatesSelector.vue
// module chunks = 0